<template>
  <div>
    <div class="comp_wrap">
      <div class="class_tabbar">
        <div class="tabbar_col" v-for="item in classList" :key="item.id"
          :class="{ 'active': item.id === parent_class_id }" @click="changeParentClass(item.id)">
          <div class="tabbar_col_img">
            <img :src="item.imgUrl" alt="">
          </div>
  
          <div class="tabbar_col_radio">
            <div></div>
            {{ item.name }}
          </div>
        </div>
      </div>
  
      <div class="cont_view">
        <div class="cont_view_title">
          鱼类常见疾病详情及处理
        </div>
  
        <div class="cont_view_flex">
          <div class="cont_view_flex_l">
            <div>
              <template v-for="item in childClassList">
                <div class="bigclass" @click="item.openFlag = !item.openFlag">
                  <p>{{ item.name }}</p>
                  <i class="el-input__icon el-icon-arrow-right" :class="{ 'open': item.openFlag }"></i>
                </div>
                <div v-show="item.openFlag">
                  <div class="smallclass" v-for="child in item.list" :key="child.id" :class="{ 'active': child.id === child_class_id }"
                    @click="changeChild(child.id)">
                    <p>{{ child.diseaseName }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="cont_view_flex_r">
            <div v-html="detailInfo ? detailInfo.diseaseContent : ''">

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-diseases',
  data() {
    return {
      classList: [],  // 所有大类子类
      childClassList: [],  // 子类列表
      parent_class_id: '',  // 大类
      child_class_id: '',  // 子类
      detailInfo: null,
    }
  },
  computed: {},
  methods: {
    changeParentClass(id) {
      if (this.parent_class_id === id) return
      this.parent_class_id = id
      this.getChildClassList()
    },
    changeChild(id) {
      if (this.child_class_id === id) return
      this.child_class_id = id

      this.detailInfo = null
      this.childClassList.forEach(d => {
        d.list.forEach(d2 => {
          if (d2.id === this.child_class_id) {
            this.detailInfo = d2
          }
        })
      })
    },
    getChildClassList() {
      const item = this.classList.find(v => v.id === this.parent_class_id)
      if (item) {
        this.childClassList = item.children.map(d => {
          d.openFlag = true
          return d
        })
      } else {
        this.childClassList = []
      }
    },
    getDiseasesList(obj) {
      obj.list = []
      const params = {
        page: 1,
        pageSize: 999999999,
        param: {
          categoryId: obj.parentId,
          diseaseCategoryId: obj.id,
        }
      }

      this.$axios({
        url: '/zhiyu-diagnosis/diseases/page',
        method: 'post',
        data: params
      }).then((r) => {
        if (r.code === '00000') {
          obj.list = r.data.list
        }
      })
    }
  },
  components: {},
  beforeMount() {
    this.$axios('/zhiyu-diagnosis/diseaseCategory/list/1').then(
      (r) => {
        console.log(r)
        if (r.code === '00000') {
          this.classList = r.data
          if (this.classList && this.classList.length) {
            this.parent_class_id = this.classList[0].id
            // 获取所有小类
            this.$axios('/zhiyu-diagnosis/diseaseCategory/list/2').then(
              (r2) => {
                if (r2.code === '00000') {
                  this.classList.forEach(d => {
                    d.children = r2.data.filter(v => v.parentId === d.id)
                  })

                  // 获取病种
                  this.classList.forEach(d => {
                    d.children.forEach(d2 => {
                      this.getDiseasesList(d2)
                    })
                  })

                  // 筛选子类列表
                  this.getChildClassList()
                }
              }
            )
          }
        }
      }
    )
  },
  mounted() {
    // 模板编译/挂载之后
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
}
</script>
<style lang="less" scoped>

.comp_wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .class_tabbar { 
    width: 100%;
    height: 212px;
    margin-top: 22px;
    overflow-x: auto;
    white-space: nowrap;
    .tabbar_col {
      display: inline-block;
      width: calc(25% - 30px);
      margin-right: 40px;
      cursor: pointer;
      &:last-of-type {
        margin-right: 0;
      }
      .tabbar_col_img {
        width: 100%;
        height: 152px;
        position: relative;
        box-sizing: border-box;
        padding: 1px;
        > img {
          width: 100%;
          height: 100%;
        }
        &:after {
          content: '';
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }
      }
      .tabbar_col_radio {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0 10px;
        color: #C3BBBB;
        font-size: 22px;
        white-space: nowrap;
        > div {
          margin-right: 12px;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          box-sizing: border-box;
          border: 2px solid #B6B6B6;
        }
      }
      &.active {
        .tabbar_col_img:after {
        }
        .tabbar_col_radio {
          > div {
            background: #fff;
            border: 8px solid #5442FF;
          }
        }
      }
    }

    /* 自定义滚动条整体样式 */
    &::-webkit-scrollbar {
      height: 6px;
      background-color: rgba(255, 255, 255, .1);
    }
    
    /* 自定义滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      height: 6px;
      background-color: rgba(255, 255, 255, .3);
      border-radius: 6px;
    }
  }

  .cont_view {
    width: 100%;
    height: 550px;
    box-sizing: border-box;
    padding: 30px 28px;
    margin-top: 30px;
    background: #f9f8f4;
    .cont_view_title {
      width: 100%;
      position: relative;
      font-size: 20px;
      padding-left: 13px;
      line-height: 1;
      &:after {
        content: '';
        position: absolute;
        width: 6px;
        height: 20px;
        background-size: 100% 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
      }
    }
    .cont_view_flex {
      width: 100%;
      height: calc(100% - 50px);
      margin-top: 30px;
      display: flex;
      overflow: hidden;
      .cont_view_flex_l {
        width: 285px;
        height: 100%;
        box-sizing: border-box;
        padding: 15px 10px 15px 10px;
        > div {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding-right: 5px;
          overflow-y: auto;
          /* 自定义滚动条整体样式 */
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: rgba(0, 0, 0, .05);
          }
          
          /* 自定义滚动条滑块样式 */
          &::-webkit-scrollbar-thumb {
            width: 6px;
            height: 6px;
            background-color: rgba(0, 0, 0, .1);
            border-radius: 6px;
          }

          .bigclass {
            cursor: pointer;
            width: 100%;
            height: 39px;
            display: flex;
            align-items: center;
            padding: 0 3px 0 10px;
            box-sizing: border-box;
            margin-bottom: 5px;
            > p {
              font-size: 18px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              width: 1px;
              flex: 1;
            }
            > i {
              font-size: 20px;
              color: #999;
              &.open {
                transform: rotate(90deg);
                transition: all .5s;
              }
            }
          }
          .smallclass {
            cursor: pointer;
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0 3px 0 35px;
            box-sizing: border-box;
            margin-bottom: 5px;
            &.active {
              background: radial-gradient(rgba(44, 41, 120, .45) 0%, rgba(34, 80, 99, .45) 100%);
            }
            > p {
              font-size: 18px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              width: 1px;
              flex: 1;
            }
          }
        }
      }
      .cont_view_flex_r {
        width: 100%;
        flex: 1;
        margin-left: 25px;
        height: 100%;
        padding: 30px;
        box-sizing: border-box;
        > div {
          width: 100%;
          height: 100%;
          font-size: 17px;
          overflow-y: auto;
          /* 自定义滚动条整体样式 */
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: rgba(0, 0, 0, .05);
          }
          
          /* 自定义滚动条滑块样式 */
          &::-webkit-scrollbar-thumb {
            width: 6px;
            height: 6px;
            background-color: rgba(0, 0, 0, .1);
            border-radius: 6px;
          }
        }
      } 
    }
  }
}
</style>
